"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.convertMediaToMessageData = void 0;
const domain_1 = require("@home-health-notify/domain");
const convertMediaToMessageData = (media) => {
    var _a, _b;
    const mediaData = media.media[0];
    const socketMedia = [
        {
            url: mediaData.url,
            text: (_a = media.title) !== null && _a !== void 0 ? _a : "",
            thumbnail: mediaData.thumbnail,
            mediaType: media.type,
        },
    ];
    const mediaToMessageData = {
        contentType: media.mediaType,
        isForwarded: false,
        type: domain_1.MESSAGE_TYPE.NORMAL,
    };
    if (media.mediaType === domain_1.MESSAGE_CONTENT_TYPE.IMAGE) {
        mediaToMessageData["images"] = socketMedia;
        mediaToMessageData.body = domain_1.SOCKET_BODY_EMOJI.IMAGE;
    }
    if (media.mediaType === domain_1.MESSAGE_CONTENT_TYPE.VIDEO) {
        socketMedia[0]["thumbnail"] = (_b = mediaData.thumbnail) !== null && _b !== void 0 ? _b : "";
        mediaToMessageData["videos"] = socketMedia;
        mediaToMessageData.body = domain_1.SOCKET_BODY_EMOJI.VIDEO;
    }
    if (media.mediaType === domain_1.MESSAGE_CONTENT_TYPE.VOICE) {
        socketMedia[0]["size"] = media.size;
        mediaToMessageData["audios"] = socketMedia;
        mediaToMessageData.body = domain_1.SOCKET_BODY_EMOJI.AUDIO;
    }
    if (media.mediaType === domain_1.MESSAGE_CONTENT_TYPE.DOCUMENT) {
        socketMedia[0]["size"] = media.size;
        socketMedia[0]["docType"] = media.type;
        // @ts-ignore
        mediaToMessageData["documents"] = socketMedia;
        mediaToMessageData.body = domain_1.SOCKET_BODY_EMOJI.DOCUMENT;
    }
    return mediaToMessageData;
};
exports.convertMediaToMessageData = convertMediaToMessageData;
